import PlatformActions from './PlatformActions'

export default class RICH88EGAMEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: 'RICH88-EGAME-001',
      platform: 'RICH88',
    }

    this.gameName = 'Ladder Climbing'
    this.roundIdSuffix = 'AC-JA001'

    this.constantGameInfo = {
      preDeduct: '0',
      tax: 'null',
    }
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      // txnIndex,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 1781061 197797647130-AC-JA001-3
      roundId: `${roundId}-${this.roundIdSuffix}`, // 1781061222798-AC-JA001
      betType: null,
      currency,
      betTime, // 2022-10-27T15:00:10.050+08:00
      betAmount,
      jackpotBetAmount: 0,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      // txnIndex,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 1781061296808774372-AC-JA001-8
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2026-06-10T11:14:56.824+08:00
      roundId: `${roundId}-${this.roundIdSuffix}`, // 1781061259802-AC-JA001
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: this.constantGameInfo,
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      // txnIndex,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId, // 1781061567512861994-AC-JA001-13
      roundId: `${roundId}-${this.roundIdSuffix}`, // 1781061555508-AC-JA001
      gameInfo: {},
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
